// Copyright (c) 2025 Deere & Company

import RgaQuestionAnswer from './rga-question-answer';
import t from 'tcomb';

const RgaQandA = t.list(RgaQuestionAnswer, 'rgaQuestionAnswer');

export const getDefaultState = () => new RgaQandA([]);

export default RgaQandA;



// WEBPACK FOOTER //
// ./src/rga/rga-search-results/state/rga-q-and-a.js